import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import icons from 'abstract-icon-pack';
import { getIcon } from '@iconify/iconify';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  constructor(private sanitizer: DomSanitizer) {}

  getIcon(name: string): SafeHtml {
    // Check if it's an iconify icon (contains ':')
    if (name.includes(':')) {
      const iconifyIcon = getIcon(name);
      if (iconifyIcon) {
        const svgString = `<svg width="18" height="18" viewBox="0 0 ${iconifyIcon.width} ${iconifyIcon.height}">${iconifyIcon.body}</svg>`;
        return this.sanitizer.bypassSecurityTrustHtml(svgString);
      }
    }
    
    // Fallback to abstract-icon-pack
    const iconSvg = icons[name];
    return iconSvg ? this.sanitizer.bypassSecurityTrustHtml(iconSvg) : '';
  }
}